import { render, staticRenderFns } from "./addPlatform.vue?vue&type=template&id=e5b656a6&scoped=true&"
import script from "./addPlatform.vue?vue&type=script&lang=js&"
export * from "./addPlatform.vue?vue&type=script&lang=js&"
import style0 from "./addPlatform.vue?vue&type=style&index=0&id=e5b656a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b656a6",
  null
  
)

export default component.exports